export const coordToObject = ([xi, yi, xf, yf]) => ({
  xi,
  yi,
  xf,
  yf
});
const ordonnerSegments = (v1, v2) => {
  if (v1[0] !== v2[0]) return v1[0] - v2[0];
  if (v1[1] !== v2[1]) return v1[1] - v2[1];
  if (v1[2] !== v2[2]) return v1[2] - v2[2];
  if (v1[3] !== v2[3]) return v1[3] - v2[3];
  return 0;
};
const orienter = segments =>
  segments.map(([x1i, y1i, x1f, y1f]) => {
    if (x1f === x1i) {
      return y1f < y1i ? [x1f, y1f, x1i, y1i] : [x1i, y1i, x1f, y1f];
    }
    return x1f < x1i ? [x1f, y1f, x1i, y1i] : [x1i, y1i, x1f, y1f];
  });

const segmentsAlignes = segments =>
  segments.reduce((pile, [x1i, y1i, x1f, y1f]) => {
    const index = pile.findIndex(collection => {
      const [x2i, y2i, x2f, y2f] = collection[0];
      const X1 = x1f - x1i;
      const Y1 = y1f - y1i;
      const X2 = x2f - x2i;
      const Y2 = y2f - y2i;
      const X3 = x2f - x1i;
      const Y3 = y2f - y1i;

      return X1 * Y2 - X2 * Y1 === 0 && X1 * Y3 - X3 * Y1 === 0;
    });
    if (index === -1) {
      return [...pile, [[x1i, y1i, x1f, y1f]]];
    }
    return [
      ...pile.slice(0, index),
      [...pile[index], [x1i, y1i, x1f, y1f]],
      ...pile.slice(index + 1)
    ];
  }, []);

const concatenerVerticales = (pile, { next, prev }) => {
  if (prev.yf >= next.yi) {
    return [
      ...pile.slice(0, pile.length - 1),
      [prev.xi, prev.yi, prev.xi, Math.max(prev.yf, next.yf)]
    ];
  }
  return [...pile, [next.xi, next.yi, next.xf, next.yf]];
};

const concatenerAutres = (pile, { next, prev }) => {
  if (prev.xf >= next.xi) {
    return [
      ...pile.slice(0, pile.length - 1),
      [
        prev.xi,
        prev.yi,
        prev.xf > next.xf ? prev.xf : next.xf,
        prev.xf > next.xf ? prev.yf : next.yf
      ]
    ];
  }
  return [...pile, [next.xi, next.yi, next.xf, next.yf]];
};

const concatenerSegmentsAlignes = vecteurs =>
  vecteurs.sort(ordonnerSegments).reduce((pile, vecteur) => {
    const next = coordToObject(vecteur);
    if (pile.length === 0) return [vecteur];

    const prev = coordToObject(pile[pile.length - 1]);
    if (prev.xi === prev.xf) {
      return concatenerVerticales(pile, { next, prev });
    }
    return concatenerAutres(pile, { next, prev });
  }, []);

const concatener = collections =>
  collections.reduce((pile, collection) => {
    if (collection.length === 1) {
      return [...pile, collection[0]];
    }
    return [...pile, ...concatenerSegmentsAlignes(collection)];
  }, []);

export default segments => {
  const segmentsOrientes = orienter(segments);
  const collections = segmentsAlignes(segmentsOrientes);
  return concatener(collections).sort(ordonnerSegments);
};
